import { render } from "./ChartHolderCard.vue?vue&type=template&id=20596b90"
import script from "./ChartHolderCard.vue?vue&type=script&lang=js"
export * from "./ChartHolderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__